import { isServer } from 'lit';
import { Logger } from '../logger/logger.js';

class AttributeValueValidator {
  constructor({
    attributeKey,
    host,
    required = false,
    validationWarningMessage,
    validationWarningTitle,
    validValues = []
  }) {
    if (isServer) {
      return;
    }
    this._attributeKey = attributeKey;
    this._host = host;
    this._required = required;
    this._validValues = validValues;
    this._validationWarningMessage = this._getValidationWarningMessage(validationWarningMessage);
    this._validationWarningTitle = this._getValidationWarningTitle(validationWarningTitle);
  }
  validate(value) {
    const hasRequiredValue = this._required && !!value;
    const hasUndefinedValidValuesAndUndefinedValue = !this._required && this._validValues?.length === 0 && typeof value === "undefined";
    const hasUndefinedValidValuesAndZeroLengthString = this._validValues?.length === 0 && value?.length === 0;
    const hasFalsyValuesAndZeroLengthValidValues = !this._required && !value && this._validValues?.length === 0;
    const hasTruthyValueAndIsIncludedInValidValues = !!value && this._validValues?.includes(value);
    const isValid = hasRequiredValue || hasUndefinedValidValuesAndUndefinedValue || hasUndefinedValidValuesAndZeroLengthString || hasFalsyValuesAndZeroLengthValidValues || hasTruthyValueAndIsIncludedInValidValues;
    if (!isValid) {
      Logger.warn({ message: this._validationWarningMessage, title: this._validationWarningTitle });
    }
  }
  _getValidationWarningMessage(message) {
    if (message) {
      return message;
    }
    if (this._required) {
      return `${this._host?.tagName} requires attribute ${this._attributeKey}`;
    }
    return `This component supports ${this._attributeKey} ${this._validValues?.join(", ")}`;
  }
  _getValidationWarningTitle(title) {
    if (title) {
      return title;
    }
    if (this._required) {
      return void 0;
    }
    return `Value of ${this._host?.tagName} attribute ${this._attributeKey} not supported`;
  }
}

export { AttributeValueValidator };
